/* eslint-disable @angular-eslint/prefer-inject */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'customFormatNumber',
  standalone: false
})
export class CustomFormatNumberPipe implements PipeTransform {

  public constructor(private translateService: TranslateService) { }

  public transform(value: number): any {
    return formatNumber(value, this.translateService.currentLang, '1.2-2');
  }
}
